import { Alert, Box, Button, Skeleton, Typography } from '@mui/material';
import { IMaintenance } from 'interfaces';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { maintenanceService } from 'services/api';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

function WaitingMaintenancesWidget() {
  const { t } = useTranslation();
  const [maintenances, setMaintenances] = useState<IMaintenance[]>();
  useEffect(() => {
    maintenanceService.getWaitingMaintenances(3, 0).then((res) => setMaintenances(res.results));
  }, []);

  return (
    <div>
      <Typography sx={{ fontSize: 14 }} color="secondary" gutterBottom>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
          <ManageAccountsIcon sx={{ fontSize: 18 }} />
          {t('dashboard.waiting-maintenances.title')}
        </Box>
      </Typography>
      {!maintenances && (
        <>
          <Skeleton variant="rectangular" height={32} />
          <br />
          <Skeleton variant="rectangular" height={32} />
          <br />
          <Skeleton variant="rectangular" height={32} />
        </>
      )}
      {maintenances &&
        maintenances.map((maintenance) => (
          <Alert
            severity={'info'}
            key={maintenance.id}
            className="mb-2"
            action={
              <NavLink
                to={`/tenant/equipments/maintenance?equipment_id=${maintenance.equipment_id}`}>
                <Button color="inherit" size="small">
                  {t('dashboard.waiting-maintenances.go')}
                </Button>
              </NavLink>
            }>
            {t('dashboard.waiting-maintenances.row-body', {
              code: maintenance.equipment,
              serial_number: maintenance.serial_number
            })}
          </Alert>
        ))}
      <div className="flex justify-center mt-2">
        <NavLink to="/tenant/equipments/maintenance/waiting">
          <Button variant="outlined" size="small">
            {t('global.view-all')}
          </Button>
        </NavLink>
      </div>
    </div>
  );
}

export default WaitingMaintenancesWidget;
